import React from 'react';
import { Redirect } from 'react-router-dom';
import { useQuery } from 'react-query';
import { findPendingInvitesForEmail } from '@/services/invitesClient';
import { appRoutes } from '@/routes';

const queryKeyPendingInvites = (email) => ['invites', 'pendingForEmail', email];

/**
 * Canonical landing redirect after successful auth.
 * Priority:
 * 1) Pending invite -> invitations hub
 * 2) No companies -> invitations hub (invite-first empty state)
 * 3) Companies exist but no active company -> select company
 * 4) Onboarding incomplete -> onboarding
 * 5) Default -> department dashboard
 */
export default function PostAuthLandingRedirect({ profile }) {
  const routes = appRoutes();
  const normalizedEmail = profile?.email?.trim().toLowerCase() || '';
  const companyList = Array.isArray(profile?.companyList)
    ? profile.companyList
    : [];
  const activeCompanyId = profile?.activeCompany?.companyId || '';
  const onboardingDone = profile?.onboardingData?.onboardingCompleted !== false;

  const { data: pendingInvites = [], isLoading } = useQuery(
    queryKeyPendingInvites(normalizedEmail),
    () => findPendingInvitesForEmail(normalizedEmail),
    {
      enabled: !!normalizedEmail,
      staleTime: 30 * 1000,
    }
  );

  if (isLoading) return null;

  if (pendingInvites.length > 0) {
    return <Redirect to={routes.invitationsHub} />;
  }

  if (companyList.length === 0) {
    return <Redirect to={routes.invitationsHub} />;
  }

  if (!activeCompanyId) {
    return <Redirect to={routes.selectCompany} />;
  }

  if (!onboardingDone) {
    return <Redirect to={routes.onboarding} />;
  }

  return <Redirect to={routes.teamDashboard} />;
}
